module.exports = __webpack_public_path__ + "img/dashboard.d8f3c9d9.svg";